import React from 'react'
import classNames from 'classnames'
import moment from 'moment'

import { IAppliedPromotion, PromotionsTypes } from '../../../../types'
import ContextMenu from 'src/components/ui/ContextMenu'
import UIMessages from 'src/utils/ui-messages'

interface IAppliedPromotionProps extends IAppliedPromotion {
  className?: string
  deleteAppliedPromotion?: (promotionId: string, walletId: string, userId: string) => any
}

const AppliedPromotion = (props: IAppliedPromotionProps) => {
  const getDeductionText = () => {
    switch (props.promotionType) {
      case PromotionsTypes.AMOUNT_OFF: {
        return `$ ${props.promotionValue}`
      }
      case PromotionsTypes.PERCENT_OFF: {
        return `${props.promotionValue} %`
      }
    }
  }

  const getRedemptionText = () => {
    const times = props.redemptionCount === 1 ? 'time' : 'times'
    return `Redeemed ${props.redemptionCount} ${times}`
  }

  const expired = props.expiresAt ? moment(props.expiresAt).isBefore(new Date()) : false
  const usedUp = props.redemptionCount >= props.maxRedemptions

  const classes = classNames('promotion-card', props.className, {
    'expired-promotion': expired || usedUp
  })

  const deleteAppliedPromotion = () => {
    if (props.deleteAppliedPromotion) {
      props.deleteAppliedPromotion(props.promotionId, props.walletId, props.userId)
    }
  }
  return (
    <div className={classes}>
      <p className='font-black font-small m0 uppercase'>{props.title}</p>
      <p className='font-grey3 font-small m0 mt1 pt1 border-top'>{getRedemptionText()}</p>
      <p className='font-grey3 font-small m0'>
        Deduction of {getDeductionText()} with a max usage of {props.maxRedemptions}{' '}
        {props.expiresAt ? `valid till ${moment(props.expiresAt).format('MM/DD/YYYY')}.` : ''}
      </p>
      <p className='font-grey3 font-small m0'>{props.createdBy ? `Applied by:  ${props.createdBy}` : ``}</p>
      <p className='font-grey3 font-small m0'>
        {props.createdAt ? `Applied at: ${moment(props.createdAt).format('MM/DD/YYYY')}` : ``}
      </p>
      {props.deleteAppliedPromotion && expired === false && usedUp === false && (
        <div className='mt1' onClick={deleteAppliedPromotion}>
          <span className='custom-btn mbsc-green-btn mbsc-btn-sm'>{UIMessages.common.removeLabel}</span>
        </div>
      )}
    </div>
  )
}

export default AppliedPromotion



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/promotions/AppliedPromotion.tsx